export default __webpack_public_path__ + "static/media/facility.ef1e1ef2.svg";